module.exports = __webpack_public_path__ + "images/emoji/tv.e1c6922aed32358dc028.png";